import CryptoJS from 'crypto-js'
const secretKey = 'secretKeyCUIRB@1234'
const encryption = (stringencrypt: string) => {
    // const secretKey = 'secretKeyCUIRB@1234'
    const encryptSecretKey = CryptoJS.SHA256(stringencrypt).toString()
    // CryptoJS.AES.encrypt(stringencrypt, secretKey).toString()
    return encryptSecretKey
    // var bytes = CryptoJS.AES.decrypt(encryptSecretKey, secretKey)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
}

const encryptionAES = (value: string) => {
    const ciphertext = CryptoJS.AES.encrypt(`${value}`, secretKey).toString()

    const replaceStr = replaceEncryptedStr(ciphertext)

    return replaceStr
}

const decryptionAES = (cryptoInfo: string) => {
    const deReplaceCiphertextStr = replaceForDecryptStr(cryptoInfo)
    const decrypted = CryptoJS.AES.decrypt(deReplaceCiphertextStr, secretKey)
    if (decrypted) {
        try {
            const str = decrypted.toString(CryptoJS.enc.Utf8)
            if (str.length > 0) {
                return str
            } else {
                return 'error 1'
            }
        } catch (e) {
            return 'error 2'
        }
    }
    return 'error 3'
}

const replaceEncryptedStr = (ciphertext: string) => {
    const replaceEncryptStr = ciphertext.toString().replaceAll('+', 'xMl3Jk').replaceAll('/', 'Por21Ld')
    return replaceEncryptStr
}

const replaceForDecryptStr = (ciphertext: string) => {
    const replaceDecryptStr = ciphertext.toString().replaceAll('xMl3Jk', '+').replaceAll('Por21Ld', '/')
    return replaceDecryptStr
}

export { encryption, encryptionAES, decryptionAES, replaceForDecryptStr }
